import { RevampedThemeColors, ThemeColor } from '@lib/constants/Colors';

type ReturnRgb = {
    rgb: true;
};

type ReturnString = {
    rgb?: false;
};

type UseThemeColorOptions = ReturnRgb | ReturnString;

type RgbArray = [number, number, number, number];

function useThemeColor(color: ThemeColor): string;
function useThemeColor(color: ThemeColor, options: ReturnRgb): RgbArray;
function useThemeColor(color: ThemeColor, options: UseThemeColorOptions = {}): RgbArray | string {
    const themeColor = RevampedThemeColors[color];

    if (options.rgb) {
        if (themeColor === 'transparent') {
            return [0, 0, 0, 0];
        }

        return hexToRgb(themeColor);
    }

    return themeColor;
}

const hexToRgb = (hexColor: `#${string}`): RgbArray => {
    const hex = hexColor.replace(/^#/, '');

    let r: number, g: number, b: number;
    if (hex.length === 3) {
        r = parseInt(hex[0] + hex[0], 16);
        g = parseInt(hex[1] + hex[1], 16);
        b = parseInt(hex[2] + hex[2], 16);
    } else if (hex.length === 6) {
        r = parseInt(hex.substring(0, 2), 16);
        g = parseInt(hex.substring(2, 4), 16);
        b = parseInt(hex.substring(4, 6), 16);
    } else {
        throw new Error('Invalid HEX color.');
    }

    return [r, g, b, 1];
};

export default useThemeColor;
